<template>
  <div class="smsc-container">
    <vx-card>
      <!-- Per Page -->
      <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
        <per-page
          :currentPerPage="per_page"
          :pageStart="pageStart"
          :pageEnd="pageEnd"
          :total="total"
          @change-per-page="ChangePerPage($event)"
        />
      </div>

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page"
        />
    </vx-card>
  </div>
</template>

<script>
// Mixins
import TableMixin from '@/mixins/table.js'

// Packages
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

// Cell Renderer components
// import CellRendererActions from './cell-renderer/CellRendererActions'

export default {
  mixins: [TableMixin],
  components: {
    AgGridVue,

    //Cell Renderer components
    // CellRendererActions
  },
  data() {
    return {
      // Selected did
      selected_did: [],
      searchProduct: '',
      list:[],
      // table header value
      columnDefs: [
        {
          headerName: 'Uploaded On',
          field: 'uploaded_on',
        //   minWidth: 240,
          sortable: true,
        },
        {
          headerName: 'Uploaded By',
          field: 'created_by',
        //   minWidth: 200,
          sortable: true
        },
        {
          headerName: 'File Name',
          field: 'file_name',
        //   minWidth: 160
        },
        {
          headerName: 'Total',
          field: 'total',
        //   filter: true,
        //   minWidth: 220
        },
        {
          headerName: 'Success',
          field: 'success',
        //   filter: true,
        //   minWidth: 220
        },
        {
          headerName: 'FAil',
          field: 'fail',
        //   minWidth: 120
        },
      ],

      // Cell Renderer components
      components: {
        // CellRendererActions
      }
    }
  },
  created() {
    // this.GetList()
  },
  methods: {
    // GetList() {
    //   this.$vs.loading()
    //   this.$store.dispatch('did/GetList', {
    //     ...this.filters,
    //     page: this.page || 0,
    //     per_page: this.per_page || 20,
    //     order_by: this.order_by || null,
    //     order_dir: this.order_dir || null,
    //     did: this.searchProduct
    //   })
    //   .then(res => {
    //     this.list = res.items.map(this.TransformList)
    //     this.total = res.total
    //   })
    //   .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
    //   .finally(() => this.$vs.loading.close())
    // },

    // SelectionChanged () {
    //   const selected_data = this.gridApi.getSelectedNodes()
    //   this.selected_did = selected_data.map(this.TransformSelectedDid)
    // },
    // ConfirmDelete () {
    //   this.$vs.dialog({
    //     type: 'confirm',
    //     color: 'danger',
    //     title: 'Are you sure?',
    //     text: 'You will not be able to recover this DIDs!',
    //     accept: this.DeleteSelection,
    //     acceptText: 'Delete'
    //   })
    //   // this.params.data.refreshData()
    // },
    // DeleteSelection () {
    //   this.$vs.loading()
    //   this.$store.dispatch('did/MassDelete', { items: this.selected_did })
    //   .then(() => {
    //     console.log('then')
    //     this.GetList()
    //     this.ShowSuccessMessage({
    //       title: 'Deleted',
    //       text: 'The selected DIDs were successfully deleted'
    //     })
    //   })
    //   .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
    //   .finally(() => this.$vs.loading.close())
    // },

    // // Notify
    // ShowSuccessMessage ({ title, text }) {
    //   this.$vs.notify({
    //     iconPack: 'feather',
    //     icon: 'icon-check',
    //     color: 'success',
    //     title,
    //     text
    //   })
    // },
    // ShowErrorMessage ({ title, text }) {
    //   this.$vs.notify({
    //     iconPack: 'feather',
    //     icon: 'icon-alert-circle',
    //     color: 'danger',
    //     title,
    //     text
    //   })
    // },

    // // Transform functions
    // TransformList(item) {
    //   return {
    //     did: item.did,
    //     created_on: format(new Date(item.created_on), 'yyyy:MM:dd HH:mm:ss'),
    //     created_by: item.created_by,
    //     vendor_name: item.vendor_name,
    //     company_name: item.company_name,
    //     iso3: item.iso3,
    //     did_type: item.did_type,
    //     state: item.state,
    //     lata: item.lata
    //   }
    // },
    // TransformSelectedDid (item) {
    //   return item.data.did
    // },
    // onQuickFilterChanged() {
    //   this.GetList()
    // },
  }
}
</script>
<style>
.vs-pagination--li {
    width:auto;
    min-width:35px;
}
    .filter_input_did{
        padding: 17px;
        padding-left: 55px;
        width: 300px;
        border: 1px solid #f5f5f5;
        font-size: 13px;
        color: gray;
        background-repeat: no-repeat;
        background-position: left center;
        outline: 0;
    }
    .has-search .form-control-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 15px;
        height: 15px;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: gray;
        margin-left: 30px;
        margin-top: 20px;
    }
</style>
<style scoped lang="scss">
  ::v-deep .ag-layout-normal{
    padding-top: 10px;
  }
</style>
